import { ETableStructureAlign, ETableStructureType, TTableStructure } from 'ui/EasTable/types';
import { EIconButtons } from 'ui/EasTable/EasTableRow/EasTableValue/constants';
import { TCountryDetails } from 'redux/reducers/country/types';

const YES_NO_FILTER: [string | null | number, string][] = [
	['true', 'Yes'],
	['false', 'No'],
];

/** Yes/No column backed by a boolean flag of the country record. */
const booleanColumn = (
	name: string,
	selector: keyof TCountryDetails,
	show: boolean,
): TTableStructure<keyof TCountryDetails> => ({
	name,
	selector,
	show,
	sortable: false,
	filterable: true,
	filter: YES_NO_FILTER,
	colSpan: 1,
	type: ETableStructureType.BOOLEAN,
	align: ETableStructureAlign.CENTER,
});

export const tableStructure: TTableStructure<keyof TCountryDetails>[] = [
	{
		name: 'ID',
		selector: 'id',
		show: true,
		sortable: true,
		filterable: false,
		colSpan: 1,
		type: ETableStructureType.NUMBER,
		align: ETableStructureAlign.LEFT,
	},
	{
		name: 'Name',
		selector: 'name',
		show: true,
		sortable: true,
		filterable: false,
		searchable: true,
		colSpan: 2,
		type: ETableStructureType.STRING,
		align: ETableStructureAlign.LEFT,
	},
	{
		name: 'ISO Alpha-2',
		selector: 'isoAlpha2',
		show: true,
		sortable: true,
		filterable: false,
		searchable: true,
		colSpan: 1,
		type: ETableStructureType.COUNTRY_CODE,
		align: ETableStructureAlign.LEFT,
	},
	{
		name: 'ISO Alpha-3',
		selector: 'isoAlpha3',
		show: true,
		sortable: true,
		filterable: false,
		colSpan: 1,
		type: ETableStructureType.STRING,
		align: ETableStructureAlign.LEFT,
	},
	{
		name: 'ISO Numeric',
		selector: 'isoNumeric',
		show: false,
		sortable: true,
		filterable: false,
		colSpan: 1,
		type: ETableStructureType.NUMBER,
		align: ETableStructureAlign.RIGHT,
	},
	{
		name: 'Currency',
		selector: 'currency',
		show: true,
		sortable: true,
		filterable: false,
		colSpan: 1,
		type: ETableStructureType.STRING,
		align: ETableStructureAlign.LEFT,
	},
	booleanColumn('EU', 'isEu', true),
	booleanColumn('Supported', 'isSupported', true),
	booleanColumn('Custom Duty', 'isCustomDutySupported', true),
	booleanColumn('Article 194', 'isArticle194Applied', false),
	booleanColumn('Special Designated Rate', 'isSpecialDesignatedRateApplied', false),
	{
		name: 'Customs Threshold',
		selector: 'customsThreshold',
		show: true,
		sortable: true,
		filterable: false,
		colSpan: 1,
		type: ETableStructureType.AMOUNT,
		align: ETableStructureAlign.RIGHT,
		currency: (item: TCountryDetails) => item.thresholdCurrency ?? '',
	},
	{
		name: 'Threshold Currency',
		selector: 'thresholdCurrency',
		show: false,
		sortable: false,
		filterable: false,
		colSpan: 1,
		type: ETableStructureType.STRING,
		align: ETableStructureAlign.LEFT,
	},
	{
		name: 'EAS Fee Multiplier',
		selector: 'easFeeMultiplierPerc',
		show: true,
		sortable: true,
		filterable: false,
		colSpan: 1,
		type: ETableStructureType.AMOUNT,
		align: ETableStructureAlign.RIGHT,
		currency: () => '%',
	},
	{
		name: 'Additional Customs Procedure',
		selector: 'additionalCustomsProcedure',
		show: false,
		sortable: false,
		filterable: false,
		colSpan: 2,
		type: ETableStructureType.STRING,
		align: ETableStructureAlign.LEFT,
		tooltip: (item: TCountryDetails) => item.additionalCustomsProcedure ?? '',
	},
	{
		name: 'Code For Fiscal Reports',
		selector: 'codeForFiscalReports',
		show: false,
		sortable: false,
		filterable: false,
		colSpan: 1,
		type: ETableStructureType.STRING,
		align: ETableStructureAlign.LEFT,
	},
	{
		name: 'Updated At',
		selector: 'updatedAt',
		show: true,
		sortable: true,
		filterable: false,
		colSpan: 1,
		type: ETableStructureType.DATE_TIME,
		align: ETableStructureAlign.CENTER,
	},
	{
		name: 'Updated By',
		selector: 'updatedBy',
		show: true,
		sortable: false,
		filterable: false,
		colSpan: 1,
		type: ETableStructureType.USER,
		align: ETableStructureAlign.LEFT,
	},
	{
		name: 'Actions',
		selector: 'actions',
		noName: true,
		show: true,
		sortable: false,
		filterable: false,
		colSpan: 1,
		type: ETableStructureType.BUTTONS,
		align: ETableStructureAlign.RIGHT,
		buttons: [
			{
				name: 'Edit',
				icon: EIconButtons.EDIT,
			},
		],
	},
];
